import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=f0837826&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=f0837826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0837826",
  null
  
)

export default component.exports